import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BottomSheetChangeVolume } from '../modals/settings/bottom-sheet-change-volume/bottom-sheet-change-volume.component';
import { MessageService, ToastService } from '@wephone-utils';
import { _ti } from '@wephone-translation';
import { AudioDeviceNotificationComponent } from '@wephone-app-phone/components/audio-device-notification/audio-device-notification.component';
import { PhoneService } from './phone/phone.service';

@Injectable()
export class AudioDeviceService {
    constructor(
        private bottomSheet: MatBottomSheet,
        private messageService: MessageService,
        private snackBar: MatSnackBar,
        private readonly phoneService: PhoneService,
    ) {
    }

    openAudioDeviceSettings(): void {
        this.bottomSheet.open(BottomSheetChangeVolume);
    }

    init(): void {
        this.messageService.subscribe('audio_device.change',
            async e => {
                const phoneConfig = await this.phoneService.loadPhoneConfig();
                if (phoneConfig.ask_user_on_new_device !== 0) {
                    this.snackBar.openFromComponent(AudioDeviceNotificationComponent,
                        {
                            data: {
                                event: e.event,
                                device_name: e.device_name,
                                in_use: e.in_use,
                                devices: e.devices
                            }
                        }
                    );
                }
            }
        );
    }
}
